import React, { useState } from "react";
import appStyle from "./appStyle.module.css";
import { FaInfoCircle } from "react-icons/fa";
import DynamicTree from "./MyQNATest";
import { IoClose } from "react-icons/io5";

// Modal Component - Using local styles from appStyle.module.css
const Modal = ({ isOpen, onClose, content, hideCloseButton = false }) => {
  if (!isOpen) return null;

  return (
    <div className={appStyle.modalOverlay}>
      <div className={appStyle.modal}>
        {!hideCloseButton && (
          <button className={appStyle.closeButton} onClick={onClose}>
            <IoClose size={20} />
          </button>
        )}
        <div className={appStyle.modalContent}>{content}</div>
      </div>
    </div>
  );
};

export const SetUpFAQ = ({ setBotContent, botContent }) => {
  return (
    <div>
      <div className={appStyle["bot-content-container"]}>
        <DynamicTree setBotContent={setBotContent} botContent={botContent} />
      </div>
    </div>
  );
};

const QNABotContent = ({ setBotContent, botContent }) => {
  console.log("dosasehojweorwe4r?in qunabotonctent");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  // Get the enabled state from botContent
  const enabledBotContent = botContent?.enabled_bot_content || false;

  const toggleRenderRootAsButtons = () => {
    setBotContent((prev) => ({
      ...prev,
      render_root_as_buttons: !prev.render_root_as_buttons,
    }));
  };

  // Simple toggle function - just like AIAgentBot
  const toggleQNABotContent = () => {
    setBotContent((prev) => ({
      ...prev,
      enabled_bot_content: !prev.enabled_bot_content,
    }));
  };

  // Info click handler
  const handleInfoClick = () => {
    const content = (
      <div style={{ padding: "10px 5px" }}>
        <h1
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            marginBottom: "8px",
            color: "#1a1a1a",
            borderBottom: "2px solid #e0e0e0",
            paddingBottom: "10px",
          }}
        >
          📋 Interactive FAQ + Lead Generation
        </h1>

        <p
          style={{
            fontSize: "15px",
            lineHeight: "1.7",
            marginBottom: "16px",
            marginTop: "12px",
            color: "#4a4a4a",
          }}
        >
          Build a structured knowledge base with clickable FAQ trees and
          optional lead capture capabilities.
        </p>

        <div style={{ marginTop: "16px" }}>
          <h3
            style={{
              fontSize: "15px",
              fontWeight: "600",
              marginBottom: "10px",
              color: "#2c2c2c",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "4px",
                height: "18px",
                backgroundColor: "#3b82f6",
                marginRight: "10px",
                borderRadius: "2px",
              }}
            ></span>
            What does this do?
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "1.7",
              color: "#4a4a4a",
              margin: "0 0 12px 0",
            }}
          >
            Create a tree-based FAQ/Q&A system where users can click through
            predefined paths to find answers. Think of it like an interactive
            decision tree or knowledge base that guides users to the right
            information.
          </p>
        </div>

        <div style={{ marginTop: "16px" }}>
          <h3
            style={{
              fontSize: "15px",
              fontWeight: "600",
              marginBottom: "10px",
              color: "#2c2c2c",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "4px",
                height: "18px",
                backgroundColor: "#22c55e",
                marginRight: "10px",
                borderRadius: "2px",
              }}
            ></span>
            Two Powerful Modes
          </h3>
          <ul
            style={{
              listStyle: "none",
              paddingLeft: "0",
              margin: "8px 0 16px 0",
            }}
          >
            <li
              style={{
                fontSize: "14px",
                lineHeight: "1.8",
                color: "#4a4a4a",
                marginBottom: "12px",
                paddingLeft: "28px",
                position: "relative",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  left: "0",
                  top: "2px",
                  color: "#3b82f6",
                  fontSize: "16px",
                }}
              >
                📚
              </span>
              <strong>FAQ/Q&A Tree Mode:</strong>
              <div
                style={{ fontSize: "13px", color: "#64748b", marginTop: "2px" }}
              >
                Build a hierarchical tree of questions and answers. Users click
                through branches to find exactly what they need. Perfect for
                support documentation, product guides, and troubleshooting.
              </div>
            </li>
            <li
              style={{
                fontSize: "14px",
                lineHeight: "1.8",
                color: "#4a4a4a",
                marginBottom: "4px",
                paddingLeft: "28px",
                position: "relative",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  left: "0",
                  top: "2px",
                  color: "#22c55e",
                  fontSize: "16px",
                }}
              >
                🎯
              </span>
              <strong>Lead Generation Mode:</strong>
              <div
                style={{ fontSize: "13px", color: "#64748b", marginTop: "2px" }}
              >
                Capture visitor information by attaching lead forms to any node
                in your FAQ tree. Leads can be stored in the Sageion Admin Panel
                or sent to external servers via orchestrated AI Agent workflows
                for custom processing.
              </div>
            </li>
          </ul>
        </div>

        <div
          style={{
            marginTop: "16px",
            padding: "14px 16px",
            background: "#f0f7ff",
            borderRadius: "8px",
            borderLeft: "3px solid #3b82f6",
          }}
        >
          <h4
            style={{
              fontSize: "13px",
              fontWeight: "600",
              color: "#1a1a1a",
              margin: "0 0 6px 0",
            }}
          >
            🔄 Lead Generation Workflow
          </h4>
          <ul
            style={{
              margin: "0",
              paddingLeft: "20px",
              fontSize: "13px",
              lineHeight: "1.8",
              color: "#475569",
            }}
          >
            <li>
              <strong>Built-in Storage:</strong> Leads are automatically stored
              in Sageion Admin Panel under the app's Lead Generation section
            </li>
            <li>
              <strong>External Integration:</strong> Connect to external servers
              via orchestrated AI Agent workflows for custom lead processing
            </li>
            <li>
              <strong>Flexible Setup:</strong> Start with FAQ mode, add lead
              capture later when ready
            </li>
          </ul>
        </div>

        <div
          style={{
            marginTop: "12px",
            padding: "10px 14px",
            background: "#fef3c7",
            borderRadius: "6px",
            borderLeft: "3px solid #f59e0b",
          }}
        >
          <p
            style={{
              fontSize: "13px",
              color: "#92400e",
              margin: "0",
              lineHeight: "1.6",
            }}
          >
            <strong>⏭️ Skip anytime:</strong> You can skip this configuration
            now and set it up later from your app dashboard. Just move to the
            next step.
          </p>
        </div>

        <div
          style={{
            marginTop: "12px",
            padding: "10px 14px",
            background: "#f0fdf4",
            borderRadius: "6px",
            borderLeft: "3px solid #22c55e",
          }}
        >
          <p
            style={{
              fontSize: "13px",
              color: "#166534",
              margin: "0",
              lineHeight: "1.6",
            }}
          >
            <strong>✨ Pro Tip:</strong> Start with a simple FAQ tree to build
            your knowledge base, then enhance it with lead generation forms at
            key decision points to capture visitor information.
          </p>
        </div>
      </div>
    );
    setModalContent(content);
    setIsModalOpen(true);
  };

  return (
    <div className={appStyle.botContent_sections}>
      <>
        <div className={appStyle.toggleContainer}>
          <div className={appStyle.titleSection}>
            <div className={appStyle.title_ic}>
              <h3>Interactive FAQ with Lead Generation</h3>
              <FaInfoCircle
                className={appStyle.suggestion_icon}
                onClick={handleInfoClick}
              />
            </div>

            <span className={appStyle.toggleText}>Enable FAQ Bot Content</span>
          </div>

          <div className={appStyle.switchWrap}>
            <span className={appStyle.toggleLabel}>
              {enabledBotContent ? "Enabled" : "Disabled"}
            </span>
            <label className={appStyle.switch}>
              <input
                type="checkbox"
                checked={enabledBotContent}
                onChange={toggleQNABotContent}
              />
              <span className={`${appStyle.slider} ${enabledBotContent ? appStyle.active : ''}`}></span>
            </label>
          </div>
        </div>

        {/* ⭐ NEW TOGGLE FOR ROOT OPTIONS - Placed directly below the first toggle container */}
        <div className={appStyle.toggleContainer} style={{ marginTop: "10px" }}>
          <div className={appStyle.titleSection}>
            <div className={appStyle.title_ic}>
              <h3>Inline Top-Level Questions</h3>
              <FaInfoCircle
                className={appStyle.suggestion_icon}
                title="If enabled, the first set of questions will appear directly inside the AI chat window instead of a 'RenderFAQ' button."
              />
            </div>
            <span className={appStyle.toggleText}>
              Show Top-Level Questions in AI Chat
            </span>
          </div>

          <div className={appStyle.switchWrap}>
            <span className={appStyle.toggleLabel}>
              {botContent?.render_root_as_buttons ? "Enabled" : "Disabled"}
            </span>
            <label className={appStyle.switch}>
              <input
                type="checkbox"
                checked={!!botContent?.render_root_as_buttons}
                onChange={toggleRenderRootAsButtons}
              />
              <span className={`${appStyle.slider} ${botContent?.render_root_as_buttons ? appStyle.active : ''}`}></span>
            </label>
          </div>
        </div>
      </>


      <div style={{ display: enabledBotContent ? "block" : "none" }}>
        <SetUpFAQ setBotContent={setBotContent} botContent={botContent} />
      </div>

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        content={modalContent}
      />
    </div>
  );
};

export default QNABotContent;